'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = 'M160 64l0 32 128 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64zM128 96l0-32c0-53 43-96 96-96s96 43 96 96l0 32 128 0 0 80-32 0 0-48-384 0 0 288 112 0 0 32-144 0 0-352 128 0zm96 160l0 224 320 0 0-224-320 0zm-32-32l384 0 0 288-384 0 0-288zm128 80l0 32c0 35.3 28.7 64 64 64s64-28.7 64-64l0-32 32 0 0 32c0 53-43 96-96 96s-96-43-96-96l0-32 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;